import { isNil, omitBy } from 'lodash';

export const filterObjNotNil = (obj: any) => omitBy(obj, isNil);
